module.exports = __webpack_public_path__ + "static/media/insert_shape_passo2.6a744a29.png";